module.exports = __webpack_public_path__ + "static/img/pn-jt.47f6bfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pn-jt.jpg
// module id = i/01
// module chunks = 1